var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axiosInstance from '../../store/AxiosSingleton';
import { Membre } from 'membre/classes/Membre.class';
import { Sortie } from 'sortie/classes/Sortie.class';
import { showSnackbar, SnackbarType } from 'common/store/actions';
import { dispatch } from 'store/store';
export class SortieService {
    /**
     * Sauvegarde la sortie
     * @param sortie Sortie à sauvegarder
     * @return Identifiant de la sortie sauvegardée, -1 si échoué
     */
    static saveSortie(sortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sortie: sortie.toRaw(),
            }, {
                params: {
                    rub: SortieService.rubModule,
                    action: 'SAVE_SORTIE',
                },
            });
            return content;
        });
    }
    /**
     * Supprime une sortie
     * @param idSortie Identifiant de la sortie à supprimer
     * @param idRaisonSuppression Identifiant de la raison de la suppression (optionnel)
     * @param commentaireSuppression Commentaire sur le suppression (optionnel)
     * @return True si la suppression a réussi, false sinon
     */
    static deleteSortie(idSortie, idRaisonSuppression, commentaireSuppression) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'DELETE_SORTIE',
                    idSortie,
                    idRaisonSuppression,
                    commentaireSuppression,
                },
            });
            return content;
        });
    }
    /**
     * Suppression des photos d'une sortie
     * @param sortieImages Liste des images à supprimer
     * @return True si la suppression a réussi, false sinon
     */
    static deleteSortieImages(sortieImages) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'DELETE_SORTIE_IMAGES',
                    sortieImages,
                },
            });
            return content;
        });
    }
    /**
     * Charges les sorties qu'organise un membre
     * @param req Les paramètres de la requête
     * @return Toutes les sorties auxquels participe un membre et le nombre total
     */
    static loadAllOutGoingsFromMember(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: SortieService.rubModule, action: 'LOAD_ALL_OUTGOINGS_FROM_MEMBER' }, request),
            });
            return {
                sorties: content.sorties.map((sortieRow) => new Sortie(sortieRow)),
                total: content.total,
            };
        });
    }
    /**
     * Sauvegarde des images d'une sortie
     * @param sortieImages Liste des images à sauvegarder
     * @return True si la sauvegarde a réussi, false sinon
     */
    static saveSortieImages(sortieImages) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((sortieImages === null || sortieImages === void 0 ? void 0 : sortieImages.length) === 0) {
                return false;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sortieImages: sortieImages.map((sortieImage) => sortieImage.toRaw()),
            }, {
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    dispatch(showSnackbar({
                        message: `Importation des photos en cours (${progress}%)`,
                        type: SnackbarType.INFO,
                        progress,
                        button: null,
                    }));
                },
                params: {
                    rub: SortieService.rubModule,
                    action: 'SAVE_SORTIE_IMAGES',
                },
            });
            return content;
        });
    }
    /**
     * Ajout d'un participant à une sortie
     * @param idSortie Identifiant de la sortie
     * @return True si l'ajout a réussi, false sinon
     */
    static addSortieParticipant(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSortie }, {
                params: {
                    rub: SortieService.rubModule,
                    action: 'ADD_SORTIE_PARTICIPANT',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'un participant à une sortie
     * @param idSortie Identifiant de la sortie
     * @return True si la suppression a réussi, false sinon
     */
    static removeSortieParticipant(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'REMOVE_SORTIE_PARTICIPANT',
                    idSortie,
                },
            });
            return content;
        });
    }
    /**
     * Charge les sorties en lien avec une autre
     * @param idSortie Identifiant de la sortie à partir de laquelle charger les autres
     * @return Les sorties en lien avec la sortie
     */
    static loadRelativeOutgoings(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_RELATIVE_OUTGOINGS',
                    idSortie,
                },
            });
            return content.map((sortieRow) => new Sortie(sortieRow));
        });
    }
    /**
     * Vérification de la participation du membre connecté à une sortie
     * @param idSortie Identifiant de la sortie
     * @return True si le membre participe à la sortie, false sinon
     */
    static checkSortieParticipant(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'CHECK_SORTIE_PARTICIPANT',
                    idSortie,
                },
            });
            return content;
        });
    }
    /**
     * Charge les participants d'une sortie
     * @param request Paramètres de la requête
     * @return Les participants de la sortie
     */
    static loadSortieParticipants(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: SortieService.rubModule, action: 'LOAD_SORTIE_PARTICIPANTS' }, request),
            });
            return {
                membres: content.membres.map((membre) => new Membre(membre.infoPublic)),
                amount: content.amount,
            };
        });
    }
    /**
     * Chargement des sorties
     * @param requestData Paramètres de la requête
     * @return Les sorties et le nombre total
     */
    static loadSorties(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: SortieService.rubModule, action: 'LOAD_SORTIES' }, requestData),
            });
            return {
                sorties: content.sorties.map((sortieRow) => new Sortie(sortieRow)),
                total: content.total,
            };
        });
    }
    /**
     * Chargement des dernières sorties crées
     * @param amount Nombre de sorties à retourner
     * @return Les dernières sorties crées
     */
    static loadLastSorties(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_LAST_SORTIES',
                    amount,
                },
            });
            return content.map((sortieRow) => new Sortie(sortieRow));
        });
    }
    /**
     * Ajout d'une sortie dans les favoris de l'utilisateur
     * @param idSortie Identifiant de la sortie
     * @return True si l'ajout a réussi, false sinon
     */
    static addSortieFavorite(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSortie }, {
                params: {
                    rub: SortieService.rubModule,
                    action: 'ADD_SORTIE_FAVORITE',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'une sortie dans les favoris de l'utilisateur
     * @param idSortie Identifiant de la sortie
     * @return True si la suppression a réussi, false sinon
     */
    static removeSortieFavorite(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'REMOVE_SORTIE_FAVORITE',
                    idSortie,
                },
            });
            return content;
        });
    }
    /**
     * Récupération du nombre total de sorties
     * @return Le nombre total de sorties
     */
    static loadSortiesAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_SORTIES_AMOUNT',
                },
            });
            return content;
        });
    }
    /**
     * Récupération d'une sortie à partir de son identifiant
     * @param idSortie Identifiant de la sortie
     */
    static loadSortieFromId(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_SORTIE_FROM_ID',
                    idSortie,
                },
            });
            return new Sortie(content);
        });
    }
    /**
     * Récupération des centres d'intérêts qui sont présent dans le plus de sorties
     * @return Les centres d'intérêts les plus populaires
     */
    static loadTrendingCentresInteret() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_TRENDING_CENTRES_INTERET',
                },
            });
            return content;
        });
    }
    /**
     * Récupération des catégories mises en avant
     * @return Les catégories mises en avant
     */
    static loadHighlightCategories() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_HIGHLIGHT_CATEGORIES',
                },
            });
            return content;
        });
    }
    /**
     * Charge les sorties favorites d'un utilisateur
     * @param request Paramètres de la requête
     */
    static loadFavorite(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: SortieService.rubModule, action: 'LOAD_SORTIE_FAVORITE' }, request),
            });
            return {
                favorites: content.favorites.map((sortieRow) => new Sortie(sortieRow)),
                total: content.total,
            };
        });
    }
    /**
     * Charge le nombre de sorties non-modérées
     * @return Le nombre de sorties non-modérées
     */
    static loadUnmoderatedSortieAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: SortieService.rubModule,
                    action: 'LOAD_UNMODERATED_SORTIE_AMOUNT',
                },
            });
            return content;
        });
    }
    /**
     * Banni un membre d'une sortie
     * @param idSortie Identifiant de la sortie
     * @param idMembre Identifiant du membre
     * @return La sortie modifiée
     */
    static saveBannissementSortie(idSortie, idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMembre, idSortie }, {
                params: {
                    rub: SortieService.rubModule,
                    action: 'SAVE_BANNISSEMENT_SORTIE',
                },
            });
            return {
                sortie: new Sortie(content.sortie),
                bannis: content.bannis.map((banni) => new Membre(banni.infoPublic)),
            };
        });
    }
    /**
     * Débanni un membre d'une sortie
     * @param idSortie Identifiant de la sortie
     * @param idMembre Identifiant du membre
     * @return Les membres bannis
     */
    static deleteBannissementSortie(idSortie, idMembre) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMembre, idSortie }, {
                params: {
                    rub: SortieService.rubModule,
                    action: 'DELETE_BANNISSEMENT_SORTIE',
                },
            });
            return content.map((membre) => new Membre(membre.infoPublic));
        });
    }
    /**
     * Récupère les membres d'une sortie
     * @param idSortie Identifiant de la sortie
     * @return Les membres bannis
     */
    static loadBannissementSortie(idSortie) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    idSortie,
                    rub: SortieService.rubModule,
                    action: 'LOAD_BANNISSEMENT_SORTIE',
                },
            });
            return content.map((membre) => new Membre(membre.infoPublic));
        });
    }
}
SortieService.rubModule = 'sortie';
//# sourceMappingURL=data:application/json;base64,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